import React from 'react';

const RangeGraph = ({key, question, current = 1, initial = 1, index = 0}) => {
    const answersMap = [
        'Never true',
        'Rarely true',
        'Sometimes true',
        'Usually true',
        'Always true',
    ]
    return (
        <div key={key} className="flex flex-row items-center space-y-2">
            {/* Label */}
            <div className="w-[70%] text-black text-[10pt] font-bold leading-tight">
                {question}
            </div>
            <div className="w-[50%] ml-6 relative">
                {/* 1) Bars */}
                <div className="absolute top-0 bottom-0 left-0 right-0 pointer-events-none">
                    {Array.from({ length: 5 }).map((_, i) => {
                        const dividerClassName = index === 0 ? "w-[1px] bg-[#84929D] h-[35px] -mb-2" : " -mb-[27px] w-[1px] bg-[#84929D] h-[35px]"
                        const dividerPaddingClassName =  `${index === 0 ? '-mt-[27px]' : '-mt-[16.5px]' } text-[8pt] text-gray-600 text-center whitespace-nowrap leading-none`;
                        return (
                        <div
                        key={i} className="absolute flex flex-col items-center"
                        style={{
                            left: `${(i / 4) * 100}%`,
                            transform: 'translateX(-50%)',
                            top: 0,
                            bottom: 0,
                        }}>
                            <span className={dividerPaddingClassName}>
                                        {index === 0 ? `${answersMap[i].replace(' true', '')}` : '' }
                                <br/>
                                {index === 0 ? 'true': '' }
                                    </span>

                    <div className={dividerClassName} />
                        </div>
                        )
                })}
                </div>
                {/* Current */}
                <div className="h-3 rounded overflow-hidden w-full">
                    <div
                        className="h-full bg-gray-800"
                        style={{ maxWidth: `${(((current-1) * 100) / 4)}%` }}
                    />
                </div>
                <div className="h-3 rounded overflow-hidden w-full">
                    <div
                        className="h-full bg-gray-400"
                        style={{ maxWidth: `${(((initial-1) * 100) / 4)}%` }}
                    />
                </div>
            </div>
        </div>
    )
};

export default RangeGraph;
